import { useEffect, useState, useCallback } from "react";

const useFetch = (apiFunction, params = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const paramsString = JSON.stringify(params);

  const fetchData = useCallback(async () => {
    if (!apiFunction) return;

    if (
      params &&
      Object.values(params).some((v) => v === null || v === undefined)
    ) {
      setData(null);
      return;
    }

    setLoading(true);
    try {
      const response = await apiFunction(params);
      setData(response.data?.result || response.data);
      setError(null);
    } catch (err) {
      setError(err.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  }, [apiFunction, paramsString]);

  useEffect(() => {
    fetchData();
    return () => {
      setLoading(false);
    };
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useFetch;
